<div class="main-container">
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
</div>
